import { render, staticRenderFns } from "./ProductCardGallery.vue?vue&type=template&id=59c5718a&"
import script from "./ProductCardGallery.vue?vue&type=script&lang=js&"
export * from "./ProductCardGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/parker/lets_code/frances-valentine/new-fv-original/FV-original/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59c5718a')) {
      api.createRecord('59c5718a', component.options)
    } else {
      api.reload('59c5718a', component.options)
    }
    module.hot.accept("./ProductCardGallery.vue?vue&type=template&id=59c5718a&", function () {
      api.rerender('59c5718a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/product-card/ProductCardGallery.vue"
export default component.exports